const levels = [
  { label: 'Дошкольники', id: 1 },
  { label: 'Мл. школьники', id: 2 },
  { label: 'Ст. школьники', id: 3 }
]

function getLevelTitle(id) {
  let level = levels.find(item => item.id === id)
  return level ? level.label : '-'
}

export {levels, getLevelTitle }